import React, { useContext } from 'react';
import classNames from 'classnames';
import { TaskbarStyles as styles } from '../css/styles';
import { LessonContext } from '../context/LessonContext';
import { backArrowWhiteIcon, nextArrowWhiteIcon, refreshIcon, showAllIcon, showAnswerIcon, submitIcon } from '../constants/icons'
import { Tooltip } from './Tooltip';
import { useTranslation } from 'react-i18next';

type TaskbarProps = {
  isFullscreen?: boolean;
  isSubmitted?: boolean;
  currentPage?: number;
  totalPages?: number;
  handleShowAnswer?: () => void;
  handleShowSingleAnswer?: () => void;
  handleSubmit?: () => void;
  handleClear?: () => void;
  setCurrentPage?: (page: number) => void;
};

const Taskbar: React.FC<TaskbarProps> = ({
  isFullscreen = false,
  isSubmitted = false,
  currentPage = 1,
  totalPages = 1,
  handleShowAnswer,
  handleShowSingleAnswer,
  handleSubmit,
  handleClear,
  setCurrentPage
}) => {
  const { currentLesson, task, checkingResult } = useContext(LessonContext);
  const { t } = useTranslation();

  return (
    // data-fullscreen-taskbar lets TaskContainer re-pin the bar to its column when the text is split
    <div
      className={classNames(styles.container, {[styles.containerFullscreen] : isFullscreen}, {[styles.containerChecking] : checkingResult})}
      data-fullscreen-taskbar={isFullscreen || undefined}
    >
      <div className={styles.taskbar}>
        {!currentLesson?.isTest && !checkingResult && !task?.isHomework && handleShowAnswer && (
          <Tooltip text={t(`bubble.showAll`)} position='bottom'>
            <button className={styles.showAll} onClick={handleShowAnswer}>
              <img src={showAllIcon} alt="Show All Answers" />
            </button>
          </Tooltip>
        )}

        {currentPage > 1 && setCurrentPage && (
          <button className={styles.pagination} onClick={() => setCurrentPage(currentPage - 1)}>
            <img src={backArrowWhiteIcon} alt="Previous" />
          </button>
        )}
        {isSubmitted && !currentLesson?.isTest && !checkingResult && handleClear && (
          <Tooltip text={t(`bubble.reset`)} position='bottom'>
            <button className={styles.showAll} onClick={handleClear}>
              <img src={refreshIcon} alt="Submit" />
            </button>
          </Tooltip>
        )}

        {currentPage === totalPages && !currentLesson?.isTest && !checkingResult && handleSubmit && (
          <Tooltip text={t(`global.submit`)} position='bottom'>
            <button className={styles.showAll} onClick={handleSubmit}>
              <img src={submitIcon} alt="Submit" />
            </button>
          </Tooltip>
        )}

        {currentPage < totalPages && setCurrentPage && (
          <button className={styles.pagination} onClick={() => setCurrentPage(currentPage + 1)}>
            <img src={nextArrowWhiteIcon} alt="Next" />
          </button>
        )}

        {!currentLesson?.isTest && !checkingResult && !task?.isHomework && handleShowSingleAnswer && (
          <Tooltip text={t(`bubble.showOne`)} position='bottom'>
            <button className={styles.showAll} onClick={handleShowSingleAnswer}>
              <img src={showAnswerIcon} alt="Show Answer" />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default Taskbar;
